import {
  IconComponentType,
} from './types/app'

import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import MenuIcon from '@mui/icons-material/Menu'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import UploadIcon from '@mui/icons-material/VerticalAlignTop'

import Login from '@mui/icons-material/AccountCircle'
import Dashboard from '@mui/icons-material/Dashboard'
import Settings from '@mui/icons-material/Settings'
import View from '@mui/icons-material/Visibility'
import Email from '@mui/icons-material/Email'
import Users from '@mui/icons-material/People'
import Done from '@mui/icons-material/Done'
import SpaceBarIcon from '@mui/icons-material/SpaceBar'
import CodeIcon from '@mui/icons-material/Code'
import GridOnIcon from '@mui/icons-material/GridOn'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import FastForwardIcon from '@mui/icons-material/FastForward'
import FastRewindIcon from '@mui/icons-material/FastRewind'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

import AccountTree from '@mui/icons-material/AccountTree'
import Org from '@mui/icons-material/Apartment'
import User from '@mui/icons-material/Person'
import Role from '@mui/icons-material/Details'

import Tag from '@mui/icons-material/Label'
import Contact from '@mui/icons-material/Contacts'
import Upload from '@mui/icons-material/CloudUpload'

import ErrorIcon from '@mui/icons-material/Error'
import Success from '@mui/icons-material/CheckCircle'
import Event from '@mui/icons-material/CallSplit'
import Cancel from '@mui/icons-material/Clear'
import CancelCircle from '@mui/icons-material/Cancel'
import Network from '@mui/icons-material/GroupWork'
import People from '@mui/icons-material/Group'
import Profile from '@mui/icons-material/AccountBox'
import List from '@mui/icons-material/List'
import Folder from '@mui/icons-material/Folder'
import FolderShared from '@mui/icons-material/FolderShared'
import FolderOpen from '@mui/icons-material/FolderOpen'
import Template from '@mui/icons-material/ArtTrack'
import Send from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save'
import PublishIcon from '@mui/icons-material/Publish'
import InputIcon from '@mui/icons-material/Input'
import AccountBoxIcon from '@mui/icons-material/AccountBox'

import Contract from '@mui/icons-material/CompareArrows'
import Expand from '@mui/icons-material/SwapHoriz'
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial'

import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft'
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter'
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight'
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop'
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'

import TextIcon from '@mui/icons-material/TextFormat'
import ImageIcon from '@mui/icons-material/Image'

import LinkIcon from '@mui/icons-material/Link'
import BoldIcon from '@mui/icons-material/FormatBold'
import ItalicIcon from '@mui/icons-material/FormatItalic'
import UnderlineIcon from '@mui/icons-material/FormatUnderlined'

import SearchIcon from '@mui/icons-material/Search'
import ColorTextIcon from '@mui/icons-material/FormatColorText'
import ColorFillIcon from '@mui/icons-material/FormatColorFill'
import ListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import ListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import QuoteIcon from '@mui/icons-material/FormatQuote'
import LabelIcon from '@mui/icons-material/Label'
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe'
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser'
import ImageSearchIcon from '@mui/icons-material/ImageSearch'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import LockIcon from '@mui/icons-material/Lock'
import Video from '@mui/icons-material/VideoLibrary'
import Undo from '@mui/icons-material/Undo'
import PodPageIcon from '@mui/icons-material/Ballot'
import PodIcon from '@mui/icons-material/GroupWork'
import WebsiteIcon from '@mui/icons-material/Language'
import TimeIcon from '@mui/icons-material/Alarm'
import CalendarIcon from '@mui/icons-material/Event'
import EuroIcon from '@mui/icons-material/Euro'
import TodayIcon from '@mui/icons-material/Today'

export const icons = {
  add: AddIcon,
  remove: RemoveIcon,
  edit: EditIcon,
  delete: DeleteIcon,
  menu: MenuIcon,
  moreVert: MoreVertIcon,
  upload: UploadIcon,
  login: Login,
  folderSpecial: FolderSpecialIcon,
  view: View,
  users: Users,
  accountTree: AccountTree,
  org: Org,
  user: User,
  role: Role,
  tag: Tag,
  contact: Contact,
  import: Upload,
  error: ErrorIcon,
  success: Success,
  event: Event,
  cancel: Cancel,
  cancelCircle: CancelCircle,
  people: People,
  profile: Profile,
  publish: PublishIcon,
  list: List,
  folder: Folder,
  folderShared: FolderShared,
  folderOpen: FolderOpen,
  template: Template,
  send: Send,
  contract: Contract,
  expand: Expand,
  alignLeft: FormatAlignLeftIcon,
  alignCenter: FormatAlignCenterIcon,
  alignRight: FormatAlignRightIcon,
  alignTop: VerticalAlignTopIcon,
  alignMiddle: VerticalAlignCenterIcon,
  alignBottom: VerticalAlignBottomIcon,
  text: TextIcon,
  image: ImageIcon,
  save: SaveIcon,
  done: Done,
  input: InputIcon,
  link: LinkIcon,
  bold: BoldIcon,
  italic: ItalicIcon,
  underline: UnderlineIcon,
  colorText: ColorTextIcon,
  colorFill: ColorFillIcon,
  bulletList: ListBulletedIcon,
  numerList: ListNumberedIcon,
  quote: QuoteIcon,
  label: LabelIcon,
  unsubscribe: UnsubscribeIcon,
  viewInBrowser: OpenInBrowserIcon,
  imageSearch: ImageSearchIcon,
  fileCopy: FileCopyIcon,
  email: Email,
  settings: Settings,
  network: Network,
  back: ArrowBackIcon,
  forward: ArrowForwardIcon,
  up: ArrowUpwardIcon,
  down: ArrowDownwardIcon,
  lock: LockIcon,
  video: Video,
  podPage: PodPageIcon,
  layoutPage: Dashboard,
  pod: PodIcon,
  website: WebsiteIcon,
  undo: Undo,
  search: SearchIcon,
  spacer: SpaceBarIcon,
  code: CodeIcon,
  grid: GridOnIcon,
  file: AttachFileIcon,
  persona: AccountBoxIcon,
  time: TimeIcon,
  calendar: CalendarIcon,
  money: EuroIcon,
  fastNext: FastForwardIcon,
  fastPrevious: FastRewindIcon,
  next: ChevronRightIcon,
  previous: ChevronLeftIcon,
  today: TodayIcon,
}

export const iconMap: Record<string, IconComponentType> = icons as unknown as Record<string, IconComponentType>
export default icons